<template>
  <v-container
    fill-height
    fluid
    class="background"
    style="max-height: 100vh;">
    <v-layout
      align-center
      justify-center>
      <v-flex
        xs12
        sm8
        md3>
        <div v-if="route == 'user'">
          <v-card
            min-height="200px"
            class="elevation-12">
            <v-toolbar color="heron_toolbar">
              <v-avatar
                color="tranparent"
                size="70">
                <img src="../assets/img/energy-control.png" >
              </v-avatar>
              <v-toolbar-title
                class="toolbar_text--text"
              >Energy Control</v-toolbar-title
              >
              <v-spacer />
              <img
                src="../assets/img/heron_icon.svg"
                width="70" >
            </v-toolbar>

            <v-card-title class="card-title">
              <v-icon
                size="60"
                color="heron_success"
                class="pr-4"
              >mdi-account-check</v-icon
              >
              Ο χρήστης {{ email }} δημιουργήθηκε!</v-card-title
              >
            <v-card-text>
              Θα ενημερωθείτε για τα επόμενα βήματα μέσω ηλεκτρονικού
              ταχυδρομείου.
            </v-card-text>
          </v-card>
        </div>
        <div v-else>
          <v-card
            min-height="200px"
            class="elevation-12">
            <v-toolbar color="heron_toolbar">
              <v-avatar
                color="tranparent"
                size="70">
                <img src="../assets/img/energy-control.png" >
              </v-avatar>
              <v-toolbar-title
                class="toolbar_text--text"
              >Energy Control</v-toolbar-title
              >
              <v-spacer />
              <img
                src="../assets/img/heron_icon.svg"
                width="70" >
            </v-toolbar>

            <v-card-title class="card-title">
              <v-icon
                size="60"
                color="heron_success"
                class="pr-4"
              >mdi-account-check</v-icon
              >
              User {{ email }} has been created!</v-card-title
              >
            <v-card-text>
              You will be informed about the next steps via e-mail.
            </v-card-text>
          </v-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    email: '',
    route: ''
  }),

  created () {
    this.email =
      this.$route.params.data !== undefined
        ? this.$route.params.data.email
        : ''
    this.route =
      this.$route.params.data !== undefined
        ? this.$route.params.data.route
        : ''

    console.log(this.$route.params.data)
  },

  metaInfo () {
    return {
      title: 'HERON Energy Control'
    }
  }
}
</script>

<style scoped>
.background {
  background: url("../assets/img/heron_background_new.jpg");
  background-size: cover;
  width: 100%;
  height: 100%;
}
.card-title {
  font-size: 20px;
}
.custom-card {
  height: 300px;
}
.v-toolbar__title {
  font-size: 1.5rem !important;
}
</style>
